import './App.css';
import React, { Suspense } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './helpers/ScrollToTop';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

/* HOME IS EAGERLY LOADED */
import Home from './pages/Home';

/* EVERYTHING ELSE IS LAZY‑LOADED */
const Collection = React.lazy(() => import('./pages/Menu'));
const About = React.lazy(() => import('./pages/About'));
const Contact = React.lazy(() => import('./pages/Contact'));

const Native = React.lazy(() => import('./pages/collections/Native'));
const Athletics = React.lazy(() => import('./pages/collections/Athletics'));
const College = React.lazy(() => import('./pages/collections/College'));
const Entertainment = React.lazy(() => import('./pages/collections/Entertainment'));
const HighSchool = React.lazy(() => import('./pages/collections/HighSchool'));
const Olympians = React.lazy(() => import('./pages/collections/Olympians'));
const Politics = React.lazy(() => import('./pages/collections/Politices'));
const Ushl = React.lazy(() => import('./pages/collections/Ushl'));

const Person = React.lazy(() => import('./pages/Person'));
const SignedItem = React.lazy(() => import('./pages/SignedItem'));
const Explore = React.lazy(() => import('./pages/Explore'));
const DataCheck = React.lazy(() => import('./pages/admin/DataCheck'));

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <ScrollToTop />

        <Suspense fallback={<div style={{ padding: "2rem", textAlign: "center" }}>Loading…</div>}>

          <Routes>
            {/* HOME IS EAGERLY LOADED */}
            <Route path="/" element={<Home />} />

            {/* EVERYTHING ELSE IS LAZY */}
            <Route path="/collection" element={<Collection />} />
            <Route path="/collection/native_nebraskans" element={<Native />} />
            <Route path="/collection/neb_hs" element={<HighSchool />} />
            <Route path="/collection/neb_college" element={<College />} />
            <Route path="/collection/athletics" element={<Athletics />} />
            <Route path="/collection/entertainment" element={<Entertainment />} />
            <Route path="/collection/olympians" element={<Olympians />} />
            <Route path="/collection/politics" element={<Politics />} />
            <Route path="/collection/ushl" element={<Ushl />} />

            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />

            <Route path="/person/:id" element={<Person />} />
            <Route path="/item/:id" element={<SignedItem />} />

            <Route path="/featured-collection" element={<Explore />} />

            <Route path="/admin/datacheck" element={<DataCheck />} />
          </Routes>

        </Suspense>

        <Footer />
      </Router>
    </div>
  );
}

export default App;
